import { memo } from 'react'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'

type ProductDescriptionProps = {
  contentOne: string
}

const ProductDescription = ({ contentOne }: ProductDescriptionProps) => {
  return (
    <>
      {contentOne && (
        <article
          data-testid="productDescription"
          className="productDescription
                w-full
                flex flex-row bg-white items-center mt-8
                justify-between px-8 pb-4 pt-8 text-neutral06 text-sm font-medium"
        >
          <div
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(contentOne),
            }}
          />
        </article>
      )}
    </>
  )
}

export default memo(ProductDescription)
